import { render, staticRenderFns } from "./DeleteBackupDialog.vue?vue&type=template&id=10e6ec58&"
import script from "./DeleteBackupDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteBackupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports